<div class="responsive-background" [attr.data-cart-visible]="cartVisible" (click)="toggleResponsiveCartView($event)">
  <div class="compact-cart product-card-list-container table-responsive">
    <table class="table product-card-list">
      <thead>
        <tr>
          <th>{{ "modeso_cart_compact-cart_title" | injectedText | async }}</th>
          <th><button class="ml-auto close-button" (click)="toggleResponsiveCartView($event)">&times;</button></th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let product of (carts$ | async)?.cart?.products">
          <td>
            <div class="product-container">
              <div class="image-container">
                <img id="productImg" src={{product.image}} alt="product-alt">
              </div>
              <div class="product-details">
                <span id="productTitle" class="product-title">{{product.title}}</span>
                <!-- 
                  leaving this as we might need packaging in future
                  
                <p id="productDescription" class="product-desc">
                  {{ product.isPackagingSelected ? 'Geschenkverpackung' : 'Keine Verpackung' }}</p>
                -->
                <p id="productAmount" class="product-desc"> {{ product.amount }}x</p>
              </div>
            </div>
          </td>
          <td id="productPrice" class="price"> CHF
            {{ product.isPackagingSelected ? ( (product.amount * ( product.price + product.packagePrice ) | number : '1.2'))  :  ( product.amount * product.price) | number : '1.2' }}
          </td>
        </tr>
        <!-- TODO refactor to not be a table -->
        <ng-content select="[afterProductList]"></ng-content>
        <tr>
          <td colspan="2">
            <cart-total-option 
            [cartTotalPrice]='(carts$ | async)?.totalPrice'
            [additionalCharges]='additionalCharges'
            >
            </cart-total-option>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>
<div class="responsive-action-footer">
  <div class="responsive-mobile">
    <cart-total-option
      [cartTotalPrice]='(carts$ | async)?.totalPrice'
      [additionalCharges]='additionalCharges'>
    </cart-total-option>
  </div>
  <div class="action-buttons">
    <div class="responsive-mobile">
      <button class="btn-cta btn-cta-secondary summary-button" (click)="toggleResponsiveCartView($event)">
        {{ "modeso_summary_button" | injectedText | async }}
      </button>
    </div>
    <ng-content select="[afterTotal]"></ng-content>
  </div>
</div>